function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M282.014 223.785C330.065 224.452 345.976 234.921 377.147 247.82C324.076 198.268 242.398 196.19 186.881 242.979C212.202 232.965 235.251 223.133 282.014 223.785Z",
  fill: "currentColor"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M562.201 140.56C562.616 140.93 563.241 140.93 563.657 140.561C564.073 140.191 564.149 139.568 563.833 139.109C496.43 51.3802 392.34 0 282.014 0C171.688 0 67.5971 51.3802 0.194103 139.109C-0.121082 139.568 -0.0454486 140.191 0.370307 140.561C0.786064 140.93 1.41106 140.93 1.82637 140.56C77.1285 67.8861 177.585 31.5319 282.014 31.656C386.473 31.5093 486.877 67.8652 562.201 140.56Z",
  fill: "currentColor"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M282.014 137.576C364.306 137.468 443.503 169.056 503.286 225.83C503.689 226.244 504.348 226.262 504.773 225.87C505.198 225.478 505.237 224.818 504.861 224.379C451.118 155.747 369.261 110.368 282.303 110.368C195.345 110.368 112.91 155.747 59.1666 224.379C58.7904 224.818 58.8294 225.478 59.2547 225.87C59.6801 226.262 60.3383 226.244 60.7421 225.83C120.524 169.056 199.722 137.468 282.014 137.576Z",
  fill: "currentColor"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M282.014 467.96C330.065 467.281 345.976 456.628 377.147 443.503C324.076 493.925 242.398 496.039 186.881 448.429C212.202 458.619 235.251 468.623 282.014 467.96Z",
  fill: "currentColor"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M562.201 551.44C562.616 551.07 563.241 551.07 563.657 551.439C564.073 551.809 564.149 552.432 563.833 552.891C496.43 640.62 392.34 692 282.014 692C171.688 692 67.5971 640.62 0.194103 552.891C-0.121082 552.432 -0.0454486 551.809 0.370307 551.439C0.786064 551.07 1.41106 551.07 1.82637 551.44C77.1285 624.114 177.585 660.468 282.014 660.344C386.473 660.491 486.877 624.135 562.201 551.44Z",
  fill: "currentColor"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M282.014 553.588C364.306 553.697 443.503 521.924 503.286 464.818C503.689 464.401 504.348 464.383 504.773 464.777C505.198 465.171 505.237 465.835 504.861 466.277C451.118 535.311 369.261 580.955 282.303 580.955C195.345 580.955 112.91 535.311 59.1666 466.277C58.7904 465.835 58.8294 465.171 59.2547 464.777C59.6801 464.383 60.3383 464.401 60.7421 464.818C120.524 521.924 199.722 553.697 282.014 553.588Z",
  fill: "currentColor"
});

var SvgRipple = function SvgRipple(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 565 692",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgRipple, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ripple.846f13a0.svg";
export { ForwardRef as ReactComponent };